{
  "search": "Vyhľadávať",
  "searchWithin": "Vyhľadávať v rozsahu"
}
